import { IGetAllChecklistEntregaAmbienteUseCase } from "../../../presentation/useCases/read/get_all_checklist_entrega_ambiente_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { ChecklistEntregaAmbienteModel } from "../../models/checklist_entrega_ambiente";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetAllChecklistEntregaAmbienteUseCase
 */

export class GetAllChecklistEntregaAmbienteUseCase
  extends BasePaginatedUseCase<ChecklistEntregaAmbienteModel>
  implements IGetAllChecklistEntregaAmbienteUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) {
    super();
  }

  async execute(
    idChecklistEntrega: number,
    descricao?: string,
    page?: number,
    rowsPerPage?: number
  ): Promise<void> {
    const result = await this.repository.getAllChecklistEntregaAmbientes(
      idChecklistEntrega,
      descricao,
      page,
      rowsPerPage
    );

    this._items = result.items;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;

  }
}
